<template>
  <div>
    <transition name="lpt-modal-fade">
      <generic-modal
        v-if="!!body"
        :body="body"
        :title="title"
        :showConfirm="showConfirm"
        @close="closeModal"
        @confirm="onConfirmFunction"/>
    </transition>

    <div class="global-alerts">
      <template v-if="!!localizedInfoMsgs">
        <div v-for="msg in localizedInfoMsgs" class="alert alert-warning alert-dismissable">
          <button class="close" aria-hidden="true" data-dismiss="alert" type="button">&times;</button>
          <p v-html="msg"/>
        </div>
      </template>
      <template v-if="!!localizedErrorMsgs">
        <div v-for="msg in localizedErrorMsgs" class="alert alert-danger alert-dismissable">
          <button class="close" aria-hidden="true" data-dismiss="alert" type="button">&times;</button>
          <p v-html="msg"/>
        </div>
      </template>
      <template v-if="!!localizedConfMsgs">
        <div v-for="msg in localizedConfMsgs" class="alert alert-info alert-dismissable">
          <button class="close" aria-hidden="true" data-dismiss="alert" type="button">&times;</button>
          <p v-html="msg"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import CONST from '../../../utils/Constants';
import GenericModal from "./GenericModal";
import { EventBus } from '@global/event-bus';

export default {
  name: "NotificationCenter",
  components: {GenericModal},
  data() {
    return {
      infoMsgs: this.$parent.$options.infoMsgs,
      errorMsgs: this.$parent.$options.errorMsgs,
      confMsgs: this.$parent.$options.confMsgs,
      localizedInfoMsgs: [],
      localizedErrorMsgs: [],
      localizedConfMsgs: [],
      body: null,
      showConfirm: true,
      onConfirmFunction: function () {
        console.log("confirm");
      }
    }
  },
  created() {
    EventBus.$on(CONST.EVENT.NOTIFICATION.INFO, msg => {
      this.notifyInfo(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.WARN, msg => {
      this.notifyWarn(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.ERROR, msg => {
      this.notifyError(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.DEFAULT, msg => {
      this.notifyDefault(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.BANNER_INFO, msg => {
      this.notifyBannerInfo(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.BANNER_CONF, msg => {
      this.notifyBannerConf(msg);
    });
    EventBus.$on(CONST.EVENT.NOTIFICATION.BANNER_ERROR, msg => {
      this.notifyBannerError(msg);
    });
  },
  mounted() {
    this.$nextTick(function () {
      EventBus.$on(CONST.EVENT.MODAL.CLOSE, () => {
        this.closeModal();
      });
      EventBus.$on(CONST.EVENT.MODAL.GENERIC, ({title, body, showConfirm, onConfirmFunction}) => {
        this.title = title;
        this.body = body;
        this.showConfirm = showConfirm;
        this.onConfirmFunction = onConfirmFunction;
      });
    });
    this.checkGlobalMessage();
  },
  methods: {
    notifyInfo(msg) {
      this.$toast.info(msg);
    },
    notifyWarn(msg) {
      this.$toast.warning(msg);
    },
    notifyError(msg) {
      this.$toast.error(msg);
    },
    notifyDefault(msg) {
      this.$toast.default(msg);
    },
    closeModal() {
      this.body = null;
    },
    notifyBannerInfo(msg) {
      this.localizedInfoMsgs.push(msg);
      this.checkMaxLength(this.localizedInfoMsgs);
    },
    notifyBannerConf(msg) {
      this.localizedConfMsgs.push(msg);
      this.checkMaxLength(this.localizedConfMsgs);
    },
    notifyBannerError(msg) {
      this.localizedErrorMsgs.push(msg);
      this.checkMaxLength(this.localizedErrorMsgs);
    },
    checkMaxLength(msgs){
      if(msgs.length > 3){
        msgs.shift();
      }
      setTimeout(function () {
        msgs.shift();
      }, 10000);
    },
    checkGlobalMessage() {
      const $this = this;
      if (!!this.infoMsgs) {
        this.infoMsgs.forEach(function (msg) {
          $this.notifyBannerInfo($this.$t(msg.code, msg.attributes));
        })
      }
      if (!!this.errorMsgs) {
        this.errorMsgs.forEach(function (msg) {
          $this.notifyBannerConf($this.$t(msg.code, msg.attributes));
        })
      }
      if (!!this.confMsgs) {
        this.confMsgs.forEach(function (msg) {
          $this.notifyBannerError($this.$t(msg.code, msg.attributes));
        })
      }
    }
  }
}
</script>

<style>
.lpt-modal-fade-enter-active, .lpt-modal-fade-leave-active {
  transition: opacity .5s, transform .5s;
}

.lpt-modal-fade-enter, .lpt-modal-fade-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
</style>



// WEBPACK FOOTER //
// src/global/notificationCenter/components/NotificationCenter.vue